export default "__VITE_ASSET__BniN2alC__"